export const formatCurrency = (amount?: number) => {
    if (amount === undefined || amount === null) return '';

    try {
        return new Intl.NumberFormat('en-us', {
            style: 'currency',
            currency: 'USD',
            currencyDisplay: 'symbol',
            localeMatcher: 'lookup',
            minimumFractionDigits: 2,
        }).format(amount);
    } catch (e) {
        return amount?.toString();
    }
};

export const formatDate = (date?: string | Date) => {
    if (date === undefined || date === null) return '';
    const d = new Date(date);
    return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};
